import React, { useEffect } from 'react';

const TermsOfService = () => {
  // Scroll to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-parosa-bg min-h-screen py-12 md:py-20 px-4 md:px-8">
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-16 shadow-sm border border-gray-100">
        
        {/* HEADER */}
        <div className="text-center mb-12 border-b border-gray-100 pb-8">
          <h1 className="text-3xl md:text-5xl font-serif text-parosa-dark mb-4">Terms & Conditions</h1>
          <p className="text-xs uppercase tracking-widest text-gray-500 font-bold">
            Last Updated: January 8, 2026
          </p>
        </div>

        {/* CONTENT */}
        <div className="space-y-8 text-gray-700 text-sm md:text-base leading-relaxed font-sans">
          
          <section>
            <p>
              [cite_start]This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures[cite: 2].
            </p>
            <p className="mt-4">
              [cite_start]This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name <strong>parosa.co.in</strong> ('Website'), including the related mobile site and mobile application (hereinafter referred to as 'Platform')[cite: 3].
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">1. Platform Ownership</h2>
            <p>
              [cite_start]The Platform is owned by <strong>Dhayal Industries</strong>, a company incorporated under the Companies Act, 1956 with its registered office at <strong>Sri Vijaynagar, Rajasthan, India - 335704</strong> (hereinafter referred to as 'Platform Owner', 'we', 'us', 'our')[cite: 4].
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">2. Terms of Use</h2>
            <p>
              [cite_start]Your use of the Platform and services and tools are governed by the following terms and conditions ("Terms of Use") as applicable to the Platform including the applicable policies which are incorporated herein by way of reference [cite: 5-6]. [cite_start]If You transact on the Platform, You shall be subject to the policies that are applicable to the Platform for such transaction[cite: 7]. [cite_start]By mere use of the Platform, You shall be contracting with the Platform Owner and these terms and conditions including the policies constitute Your binding obligations, with Platform Owner[cite: 8].
            </p>
            <p className="mt-2">
              [cite_start]Any terms and conditions proposed by You which are in addition to or which conflict with these Terms of Use are expressly rejected by the Platform Owner and shall be of no force or effect[cite: 10]. [cite_start]These Terms of Use can be modified at any time without assigning any reason[cite: 11]. [cite_start]It is your responsibility to periodically review these Terms of Use to stay informed of updates[cite: 12].
            </p>
            <p className="mt-2 font-bold">
              [cite_start]ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING[cite: 13].
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">3. Usage of Services</h2>
            [cite_start]<p>The use of Platform and/or availing of our Services is subject to the following Terms of Use[cite: 14]:</p>
            <ul className="list-disc pl-5 space-y-2 mt-2">
              <li>
                [cite_start]To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account on the Platform[cite: 15].
              </li>
              <li>
                [cite_start]Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials offered on this website or through the Services, for any specific purpose[cite: 16]. [cite_start]You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law[cite: 17].
              </li>
              <li>
                [cite_start]Your use of our Services and the Platform is solely and entirely at your own risk and discretion for which we shall not be liable to you in any manner[cite: 18]. [cite_start]You are required to independently assess and ensure that the Services meet your requirements[cite: 19].
              </li>
              <li>
                [cite_start]The contents of the Platform and the Services are proprietary to us and are licensed to us[cite: 20]. [cite_start]You will not have any authority to claim any intellectual property rights, title, or interest in its contents[cite: 21]. [cite_start]The contents includes and is not limited to the design, layout, look and graphics[cite: 22].
              </li>
              <li>
                [cite_start]You acknowledge that unauthorized use of the Platform and/or the Services may lead to action against you as per these Terms of Use and/or applicable laws[cite: 23].
              </li>
              <li>
                [cite_start]You agree to pay us the charges associated with availing the Services[cite: 23].
              </li>
              <li>
                [cite_start]You agree not to use the Platform and/or Services for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws that might apply to you[cite: 24].
              </li>
              <li>
                [cite_start]You agree and acknowledge that website and the Services may contain links to other third party websites[cite: 25]. [cite_start]On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third party websites[cite: 26]. [cite_start]These links are provided for your convenience for provide further information[cite: 27].
              </li>
              <li>
                [cite_start]You understand that upon initiating a transaction for availing the Services you are entering into a legally binding and enforceable contract with the Platform Owner for the Services[cite: 28].
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">4. Products and Services Disclaimer</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Nature of Goods:</strong> Our products (Spices, Flours, Oils) are agricultural produce. Slight variations in color, texture, and taste may occur due to seasonal changes. This is a characteristic of natural, non-chemically treated products and is not a defect.
              </li>
              <li>
                <strong>Accuracy:</strong> We have made every effort to display as accurately as possible the colors and images of our products. We cannot guarantee that your computer monitor's display of any color will be accurate.
              </li>
              <li>
                <strong>Availability:</strong> All products are subject to availability. We reserve the right to discontinue any product at any time.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">5. Pricing and Billing</h2>
             <p>
              Prices for our products are subject to change without notice. We shall not be liable to you or to any third-party for any modification, price change, suspension, or discontinuance of the Service.
            </p>
             <p className="mt-2">
              We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household, or per order.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">6. Indemnification & Liability</h2>
            <p>
              [cite_start]You shall indemnify and hold harmless Platform Owner, its affiliates, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorney's fees, made by any third party or penalty imposed due to or arising out of Your breach of this Terms of Use, privacy Policy and other Policies, or Your violation of any law, rules or regulations or the rights (including infringement of intellectual property rights) of a third party[cite: 29].
            </p>
            <p className="mt-2">
              [cite_start]Notwithstanding anything contained in these Terms of Use, the parties shall not be liable for any failure to perform an obligation under these Terms if performance is prevented or delayed by a force majeure event[cite: 30].
            </p>
             <div className="bg-gray-50 p-4 border-l-4 border-parosa-accent mt-4">
              <p className="italic mb-2 font-bold text-gray-900">LIMITATION OF LIABILITY:</p>
              <p>
                In no case shall <strong>Dhayal Industries</strong> be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind. Our liability is strictly limited to the monetary value of the product purchased.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-serif text-parosa-dark mb-3">7. Governing Law</h2>
            <p>
              [cite_start]These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of <strong>India</strong>[cite: 31]. [cite_start]All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in <strong>Sri Vijaynagar, Rajasthan</strong>[cite: 32].
            </p>
          </section>

          <section className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-xl font-serif text-parosa-dark mb-4">Contact Information</h2>
            <p className="mb-4">
              [cite_start]All concerns or communications relating to these Terms must be communicated to us using the contact information provided below[cite: 33]:
            </p>
            
            <address className="not-italic bg-gray-50 p-6 rounded-sm">
              <strong className="block text-lg mb-2 text-parosa-dark">Dhayal Industries</strong>
              <p className="mb-1">Sri Vijaynagar, Rajasthan - 335704</p>
              <p className="mb-1">Email: <a href="mailto:support@parosa.co.in" className="text-blue-600 underline">support@parosa.co.in</a></p>
            </address>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsOfService;